import PropTypes from 'prop-types';

export const optionPropTypes = {
  all: PropTypes.bool,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  selected: PropTypes.object,
};

export const propTypes = {
  ...optionPropTypes,
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  className: PropTypes.string,
};

export const optionDefaultProps = {
  all: false,
  onChange: undefined,
  selected: undefined,
};

export const defaultProps = {
  ...optionDefaultProps,
  className: undefined,
};
